import React from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {changeUserInfo} from "../../../actions/actionFunctions";
import {IS_LOOK_JOURNEY} from "../../../config";

const AssignQuotePopupNewCustomerSelect = (props) => {

  const {property, changeUserInfo, intl, select, userInfo} = props;

  const onChange = (event) => {
    changeUserInfo({
      [property]: event.target.value
    })
  };

  return (
    <div className="ass-field">
      <select name=""
              className={"ui-input ui-input--new ass-field__input ass-field__select"
              + (!userInfo[property] && !IS_LOOK_JOURNEY ? " ass-field__input--no-value" : "")
              + (IS_LOOK_JOURNEY ? " ui-input--look" : " ui-input--select")}
              value={userInfo[property] || "placeholder"}
              onChange={onChange}>
        <option value="placeholder" disabled hidden>
          {intl.formatMessage({id: select.placeholder})}
        </option>
        {select.options.map((method, methodIndex) => {
          return <option key={methodIndex} value={method}>{method}</option>
        })}
      </select>
      <span className="ui-select-triangle"/>
    </div>
  )
};

AssignQuotePopupNewCustomerSelect.propTypes = {
  property: PropTypes.string.isRequired,
  select: PropTypes.object.isRequired,
};

const mapStateToProps = (store) => {
  return {
    userInfo: store.userState.userInfo,
    // assignQuotePopupSearchText: store.assignQuoteState.assignQuotePopupSearchText
  };
};

const mapDispatchToProps = {
  changeUserInfo
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupNewCustomerSelect)
)
